
// Common
import HTMLDsbElement from 'https://stmaadev.blob.core.windows.net/stc-maa-dev-fw-site/scripts/scriptloader/HTMLDsbElement/HTMLDsbElement-v1.0.0.es.js';
import formatPart from "./part-format.js";

//CSS
import _CSS from '../../dest/css/dsb-data.min.css';

export default class extends HTMLDsbElement {
  constructor() {
    super({'component_name':'dsb-data','css':_CSS});

    /**
     // Setup styling
    this.attachShadow({ mode: "open" });
    const style = document.createElement("style");
    let _this=this;

    style.textContent = _CSS;
    this.shadowRoot.appendChild(style);
    */

    this._formatter = formatPart(this.dsb);
    this._settings=false;
    this._data_sources = '';
    /**
    this._innerHTMLCopy = this.innerHTML;
    this.innerHTML='';
    this._innerDIV=document.createElement('div');
    if(this.hasAttribute('class'))
    {
      this._innerDIV.setAttribute('class',this.getAttribute('class'));
    }
    //this.append(this._innerDIV);
    this.shadowRoot.append(this._innerDIV);
    this._innerDIV.innerHTML=this._innerHTMLCopy;
    */


  }


  async _render()
  {
    let _this = this;
    if(this.dsb.element.innerHTML.trim() == "")
    {
      if(this.dsb.helpers.has('html','spinner'))
      {
        this.dsb.element.innerHTML=this.dsb.helpers.run('html','spinner');
      }
      else
      {
        this.dsb.element.innerHTML='Loading...';
      }
    }
    if(this.dsb.helpers.has('process','deserialize'))
    {
      let format = this.dsb.helpers.run('process','deserialize',[this.getAttribute('format')]);
      if(this.data.code==200)
      {
        let data = this.data.data;
        let type = (this.hasAttribute('type')?this.getAttribute('type'):'');
        /**let formatted = this.dsb.helpers.run(
          'format','structure',[data,format]
        );
        */
        let html = this._formatter(data,format,type);
        if(Array.isArray(html))
        {
          this.dsb.element.innerHTML='';
          for(let anElement of html)
          {
            if(anElement instanceof HTMLElement)
            {
              this.dsb.element.append(anElement);
            }
          }
        }
        else
        {
          this.dsb.element.innerHTML = html;
        }
        this.dsb.log('debug','_render','What we have to work with',{'format':format,'formatted':html,'data':data.data});
      }
    }
    else
    {
      throw 'Cannot process format...';
    }
  }
}

